import { useState } from "react";
import { getApiHeader } from 'utlis/commonfunctions';
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { Navigate, useNavigate } from "react-router-dom";
import { ThreeDots } from 'react-loader-spinner'


const SERVER_URL = process.env.REACT_APP_API_URL;


const styles = {
  wrapper: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backdropFilter: "blur(1px)",
    zIndex: 9999,
  },
};

function inputField() {
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState("pageOne");
  const [loading, setLoading] = useState(false);
  const [buttonview, setButtonView] = useState(false)
  const [checkBox, setCheckBox] = useState(false)
  const [checkBoxError, setCheckBoxError] = useState(false)
  const [disableButton, setButtonDisable] = useState(false)

  const [formData, setFormData] = useState({
    retailer_name: "",
    retailer_company_name: "",
    retailer_abn: "",
    retailer_address_line_1: "",
    retailer_address_line_2: "",
    retailer_city: "",
    retailer_state: "",
    retailer_country: 234,
    retailer_post_code: "",
    email: "",
    email_confirmation: "",
    retailer_mobile: "",
    retailer_bank_account_name: "",
    retailer_bank_name: "",
    retailer_bsb: "",
    retailer_account_number: "",
    retailer_additional_information: "",
    supportCheckbox: "",
    retailer_contact_email: ""

  });


  const [error, SetError] = useState({
    retailer_name: false,
    retailer_company_name: false,
    retailer_abn: false,
    retailer_address_line_1: false,
    retailer_address_line_2: false,
    retailer_city: false,
    retailer_state: false,
    retailer_country: false,
    retailer_post_code: false,
    email: false,
    email_confirmation: false,
    retailer_mobile: false,
    retailer_bank_account_name: false,
    retailer_bank_name: false,
    retailer_bsb: false,
    retailer_account_number: false,
    retailer_additional_information: false,
    supportCheckbox: false,
    retailer_contact_email: ""
  });

  const [errorMessage, setErrorMessage] = useState({
    retailer_name: "",
    retailer_company_name: "",
    retailer_abn: "",
    retailer_address_line_1: "",
    retailer_address_line_2: "",
    retailer_city: "",
    retailer_state: "",
    retailer_country: "",
    retailer_post_code: "",
    email: "",
    email_confirmation: "",
    retailer_mobile: "",
    retailer_bank_account_name: "",
    retailer_bank_name: "",
    retailer_bsb: "",
    retailer_account_number: "",
    retailer_additional_information: "",
    supportCheckbox: "",
    retailer_contact_email: ""
  })

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!checkBoxError) {
      console.log("supportbox error")
      setButtonDisable(true)
      setCheckBoxError(true)
      setCheckBox(true)
      return;
    } else {

      console.log("hello world")
    }

    setLoading(true)
    setActiveTab("pageTwo");
    const headers = await getApiHeader();

    try {
      const response = await axios.post(`${SERVER_URL}pid-registration`, formData, {
        headers: headers
      });
      if (response.status === 200) {
        handleBack()
        setLoading(false)
        toast.success(response?.data?.message);
      }
      console.log("response", response.data.message);

    } catch (error) {
      setLoading(false)
      setButtonView(false)
      setButtonDisable(true)
      setCheckBoxError(true)
      setCheckBox(true)
      const errorMessage = error?.response?.data?.message || "An error occurred";
      if (typeof errorMessage === 'object') {
        Object.keys(errorMessage).forEach(key => {
          errorMessage[key].forEach(message => {
            SetError(prevError => ({
              ...prevError,
              [key]: true
            }));
            setErrorMessage(prevError => ({
              ...prevError,
              [key]: message
            }));
          });
        });
        handlePrevious(e)
      } else {
        toast.error(errorMessage);
        handlePrevious(e)
        setLoading(false)
      }
    }
  };




  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "retailer_mobile") {
      if (/^\d{0,10}$/.test(value)) {
        console.log("entered");
        setFormData({ ...formData, [name]: value });
      }
    } else if (name === 'retailer_account_number') {
      if (/^\d{0,20}$/.test(value)) {
        setFormData({ ...formData, [name]: value });
      }
    } else if (name === 'retailer_name') {
      if (/^[a-zA-Z0-9 ]{0,50}$/.test(value)) {
        setFormData({ ...formData, [name]: value });
      }
    }else if (name === 'retailer_post_code') {
      if (/^\d{0,4}$/.test(value)) {
        setFormData({ ...formData, [name]: value });
      }
    }else if (name === 'retailer_abn') {
      if (/^\d{0,11}$/.test(value)) { 
        setFormData({ ...formData, [name]: value });
      }
    }
    else if (name === "supportCheckbox") {
      setCheckBoxError(true)
      setButtonDisable(false)
      setCheckBox(false)
      setFormData({ ...formData, [name]: value });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
    setButtonView(true)
  };

  const pageHandler = (e) => {
    e.preventDefault();
    setActiveTab("pageTwo")
  }

  const handlePrevious = (e) => {
    e.preventDefault();
    setActiveTab("pageOne");
  };

  const handleBack = () => {
    setFormData("")
    setActiveTab("pageOne");
  };




  return (
    <>

      {activeTab == "pageOne" && (
        <div>
          <div className="formbold-main-wrapper">
            <div className="formbold-form-wrapper">
              <h3 style={{ textAlign: "center" }}> Retailer Registration</h3>
              <p style={{ textAlign: "center" }}> Enter the details to open the Telsim retailer account</p>
              <form action="" method="" onSubmit={pageHandler}  autoComplete="off">
                <div className="formbold-mb-5">
                  <label htmlFor="retailerName" className="formbold-form-label">
                    Retailer Name <span class="astrix-color">*</span>
                  </label>
                  <input
                    type="text"
                    name="retailer_name"
                    value={formData.retailer_name}
                    id="name"
                    placeholder="Enter  First name and Last name"
                    className={error.retailer_name ? "formbold-form-input form-error" : "formbold-form-input"}
                    onChange={handleChange}
                    required={true}
                  />

                  {error.retailer_name && (
                    <p className="error-label">{errorMessage.retailer_name}</p>
                  )}

                </div>
                <div className="formbold-mb-5">
                  <label htmlFor="companyName" className="formbold-form-label">
                    Company/Store Name <span class="astrix-color">*</span>
                  </label>
                  <input
                    type="text"
                    name="retailer_company_name"
                    value={formData.retailer_company_name}
                    id="companyName"
                    placeholder="Enter Company name/Trading name "
                    className={error.retailer_company_name ? "formbold-form-input form-error" : "formbold-form-input"}
                    onChange={handleChange}
                    required={true}
                  />
                  {error.retailer_company_name && (
                    <p className="error-label">{errorMessage.retailer_company_name} </p>
                  )}
                </div>
                <div className="formbold-mb-5">
                  <label htmlFor="abn" className="formbold-form-label">
                    ABN  <span class="astrix-color">*</span>
                  </label>
                  <input
                    type="text"
                    name="retailer_abn"
                    id="abn"
                    placeholder="Active ABN is mandatory"
                    className={error.retailer_abn ? "formbold-form-input form-error" : "formbold-form-input"}
                    value={formData.retailer_abn}
                    onChange={handleChange}
                    maxLength={11}
                    required={true}
                  />
                  {error.retailer_abn && (
                    <p className="error-label">{errorMessage.retailer_abn} </p>
                  )}
                </div>
                <div className="formbold-mb-5">
                  <label htmlFor="Address_Line_1" className="formbold-form-label">
                    Company/Store address  <span class="astrix-color">*</span>
                  </label>
                  <input
                    type="text"
                    name="retailer_address_line_1"
                    id="Address_Line_1"
                    value={formData.retailer_address_line_1}
                    className={error.retailer_address_line_1 ? "formbold-form-input form-error" : "formbold-form-input"}
                    onChange={handleChange}
                    placeholder="Address Line 1"
                    required={true}
                    autoComplete="new-password"
                  />
                  {error.retailer_address_line_1 && (
                    <p className="error-label">{errorMessage.retailer_address_line_1} </p>
                  )}
                </div>
                <div className="formbold-mb-5">
                  <label htmlFor="Address_Line_2" className="formbold-form-label">
                  </label>
                  <input
                    type="text"
                    name="retailer_address_line_2"
                    id="Address_Line_2"
                    value={formData.retailer_address_line_2}
                    onChange={handleChange}
                    placeholder="Address Line 2"
                    className={error.retailer_address_line_2 ? "formbold-form-input form-error" : "formbold-form-input"}
                    autoComplete="new-password"

                  />
                  {error.retailer_address_line_2 && (
                    <p className="error-label">{errorMessage.retailer_address_line_2} </p>
                  )}


                </div>
                <div className="formbold-mb-5 formbold-pt-3">
                  <label className="formbold-form-label formbold-form-label-2">
                  </label>
                  <div className="flex flex-wrap formbold--mx-3">
                    <div className="w-full sm:w-half formbold-px-3">
                      <div className="formbold-mb-5">
                      <label htmlFor="Address_Line_1" className="formbold-form-label">
                        City <span class="astrix-color">*</span>
                      </label>
                        <input
                          type="text"
                          name="retailer_city"
                          id="city"
                          value={formData.retailer_city}
                          onChange={handleChange}
                          placeholder="Enter City"
                          className={error.retailer_city ? "formbold-form-input form-error" : "formbold-form-input"}
                          autoComplete="new-password"

                        />
                        {error.retailer_city && (
                          <p className="error-label">{errorMessage.retailer_city}</p>
                        )}
                      </div>
                    </div>

                    <div className="w-full sm:w-half formbold-px-3">
                    <label htmlFor="Address_Line_1" className="formbold-form-label">
                        State <span class="astrix-color">*</span>
                      </label>
                      <select
                        className={error.retailer_state ? "formbold-form-input form-error" : "formbold-form-input"}
                        name="retailer_state"
                        id="state"
                        value={formData.retailer_state}
                        onChange={handleChange}
                      >
                        <option value="">Select State</option>
                        <option value="Act">ACT</option>
                        <option value="NSW">NSW</option>
                        <option value="NIT">NIT</option>
                        <option value="QLD">QLD</option>
                        <option value="SA">SA</option>
                        <option value="TAS">TAS</option>
                        <option value="VIC">VIC</option>
                        <option value="WA">WA</option>
                      </select>
                      {error.retailer_state && (
                        <p className="error-label">{errorMessage.retailer_state}</p>
                      )}
                    </div>

                    <div className="w-full sm:w-half formbold-px-3">
                      <div className="formbold-mb-5">
                      <label htmlFor="Address_Line_1" className="formbold-form-label">
                        Post Code <span class="astrix-color">*</span>
                      </label>
                        <input
                          type="tel"
                          name="retailer_post_code"
                          value={formData.retailer_post_code}
                          onChange={handleChange}
                          id="post-code"
                          placeholder="Post Code"
                          className={error.retailer_post_code ? "formbold-form-input form-error" : "formbold-form-input"}
                          maxLength={4}
                          autoComplete="new-password"
                        />
                        {error.retailer_post_code && (
                          <p className="error-label">{errorMessage.retailer_post_code} </p>
                        )}
                      </div>
                    </div>
                    <div className="w-full sm:w-half formbold-px-3">
                    <label htmlFor="Address_Line_1" className="formbold-form-label">
                        Country <span class="astrix-color">*</span>
                      </label>
                      <select
                        className={error.retailer_country ? "formbold-form-input form-error" : "formbold-form-input"}
                        name="retailer_country"
                        id="retailer_country"
                      // value={formData.retailer_country}
                      // onChange={handleChange}
                      >
                        <option value="Australia">Australia</option>

                      </select>
                      {error.retailer_country && (
                        <p className="error-label">{errorMessage.retailer_country}</p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="formbold-mb-5">
                  <label htmlFor="email" className="formbold-form-label">
                    Email <span class="astrix-color">*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter your email "
                    className={error.email ? "formbold-form-input form-error" : "formbold-form-input"}
                    required={true}
                    autoComplete="new-password"
                  />
                  {error.email && (
                    <p className="error-label">{errorMessage.email}</p>
                  )}
                </div>
                <div className="formbold-mb-5">
                  <label htmlFor="email" className="formbold-form-label">
                    Confirm Email <span class="astrix-color">*</span>
                  </label>
                  <input
                    type="email"
                    name="email_confirmation"
                    id="email"
                    value={formData.email_confirmation}
                    onChange={handleChange}
                    placeholder="Confirm your email "
                    className={error.email_confirmation ? "formbold-form-input form-error" : "formbold-form-input"}
                    required={true}
                    autoComplete="new-password"
                  />
                  {error.email_confirmation && (
                    <p className="error-label">{errorMessage.email_confirmation}</p>
                  )}

                </div>
                <div className="formbold-mb-5">
                  <label htmlFor="phone" className="formbold-form-label">
                    Phone number <span class="astrix-color">*</span>
                  </label>
                  <input
                    type="tel"
                    name="retailer_mobile"
                    id="phone"
                    value={formData.retailer_mobile}
                    onChange={handleChange}
                    placeholder="Enter your phone number "
                    className={error.retailer_mobile ? "formbold-form-input form-error" : "formbold-form-input"}
                    pattern={"0[0-9]{9}"}
                    required={true}
                    autoComplete="new-password"
                  />
                  {error.retailer_mobile && (
                    <p className="error-label">{errorMessage.retailer_mobile} </p>
                  )}
                </div>
                
                  <div>
                    <button className="formbold-btn" type="submit" >Next <i class="fa fa-caret-right"></i></button>
                  </div>
                
              </form>
            </div>
          </div>
        </div>
      )}

      {activeTab === "pageTwo" && (
        <>
          {loading && (
            <div style={styles.wrapper}>
              <ThreeDots
                visible={loading}
                height="80"
                width="80"
                color="#C11D6C"
                radius="9"
                ariaLabel="three-dots-loading"
              />
            </div>
          )}
          <div className="formbold-main-wrapper">
            <div className="formbold-form-wrapper">
              <h3 style={{ textAlign: "center" }}>
                Bank Account Details
              </h3>
              <p style={{ textAlign: "center" }}>
                Provide your bank account details to send the payments.
              </p>
              <form action="" method="" onSubmit={handleSubmit}>

                <div className="formbold-mb-3">
                  <label htmlFor="age" className="formbold-form-label">
                    {" "}
                    Bank Account Name
                  </label>
                  <p>Payments will be made only to company bank accounts. Personal accounts not accepted.</p>

                  <input
                    type="text"
                    name="retailer_bank_account_name"
                    id="retailer_bank_account_name"
                    value={formData.retailer_bank_account_name}
                    onChange={handleChange}
                    placeholder="Enter your bank account name. Bank account name should match company name."
                    className={error.retailer_bank_account_name ? "formbold-form-input form-error" : "formbold-form-input"}
                    autoComplete="off"
                  />
                  {error.retailer_bank_account_name && (
                    <p className="error-label">{errorMessage.retailer_bank_account_name} </p>
                  )}
                </div>

                <div className="formbold-mb-3">
                  <label htmlFor="age" className="formbold-form-label">
                    Bank Name
                  </label>
                  <input
                    type="text"
                    name="retailer_bank_name"
                    id="retailer_bank_name"
                    placeholder="Enter Bank Name"
                    className={error.retailer_bank_name ? "formbold-form-input form-error" : "formbold-form-input"}
                    value={formData.retailer_bank_name}
                    onChange={handleChange}
                    autoComplete="off"
                  />
                  {error.retailer_bank_name && (
                    <p className="error-label">{errorMessage.retailer_bank_name}</p>
                  )}
                </div>

                <div className="formbold-mb-3">
                  <label htmlFor="age" className="formbold-form-label">
                    BSB
                  </label>
                  <input
                    type="text"
                    name="retailer_bsb"
                    id="retailer_bsb"
                    value={formData.retailer_bsb}
                    onChange={handleChange}
                    maxLength={6}
                    placeholder="Enter BSB"
                    className={error.retailer_bsb ? "formbold-form-input form-error" : "formbold-form-input"}
                    autoComplete="off"
                  />
                  {error.retailer_bsb && (
                    <p className="error-label">{errorMessage.retailer_bsb} </p>
                  )}
                </div>
                <div className="formbold-mb-3">
                  <label htmlFor="age" className="formbold-form-label">
                    Account Number
                  </label>
                  <input
                    type="phone"
                    name="retailer_account_number"
                    id="retailer_account_number"
                    value={formData.retailer_account_number}
                    onChange={handleChange}
                    placeholder="Enter Bank Account Number"
                    className={error.retailer_account_number ? "formbold-form-input form-error" : "formbold-form-input"}
                    min={0} max={9999999999}
                    autoComplete="off"
                  />
                  {error.retailer_account_number && (
                    <p className="error-label">{errorMessage.retailer_account_number} </p>
                  )}
                </div>
                <div className="formbold-mb-3">
                  <label htmlFor="age" className="formbold-form-label">
                    {" "}
                    Additional Information
                  </label>
                  <input
                    type="text"
                    name="retailer_additional_information"
                    id="retailer_additional_information"
                    placeholder="Additional Information"
                    className={error.retailer_additional_information ? "formbold-form-input form-error" : "formbold-form-input"}
                    value={formData.retailer_additional_information}
                    onChange={handleChange}
                    autoComplete="off"
                  />
                  {error.retailer_additional_information && (
                    <p className="error-label">{errorMessage.retailer_additional_information} </p>
                  )}
                </div>

                <div className="formbold-mb-3">
                  <label htmlFor="age" className="formbold-form-label">
                    {" "}
                    Finance Person Details <span class="astrix-color">*</span>
                  </label>
                  <input
                    type="email"
                    name="retailer_contact_email"
                    id="retailer_contact_email "
                    placeholder="Contact Email"
                    className={error.retailer_contact_email ? "formbold-form-input form-error" : "formbold-form-input"}
                    value={formData.retailer_contact_email}
                    onChange={handleChange}
                    required={true}
                    autoComplete="off"
                  />
                  {error.retailer_contact_email && (
                    <p className="error-label">{errorMessage.retailer_contact_email} </p>
                  )}
                </div>

                <div className="formbold-mb-3">
                  <label htmlFor="email" className="formbold-form-label">
                  Terms & Conditions
                  </label>
                  <div
                    className={error.supportCheckbox ? "commission-details form-error" : "commission-details"}
                  >
                    <ul>
                      <li>Completion of each successful application for SIM activation is entitled to a sales commission as compensation to the retailer.</li>
                      <li>Retailer commission details will be emailed when the retailer registration process is completed online and approved by Telsim.</li>
                      <li>The commission schedules of different products/plans will vary at different periods.</li>
                      <li>A higher/lower commission schedule may be given on promotional items and periods, which will be communicated to the retailer.</li>
                      <li>The Company reserves the right to modify the commission to reflect the market situation in the best interests of the retailer.</li>
                      <li>Changes relating to commissions will be communicated to the retailer in writing.</li>
                      <li>Commission payments will be made on a monthly basis directly to the nominated bank account by the retailer.</li>
                      <li>In case of a dispute or incorrect report, the retailer must report to the Company within 30 days of receiving the monthly report.</li>
                      <li>All activations will be validated by the Telsim Fraud Management team before the commissions are paid out.</li>
                      <li>The retailer shall not be entitled to commission on the proceeds of any sale not received or retained by the Company due to the insolvency of a customer. If any such commission has already been paid to the retailer prior to such insolvency, the retailer agrees to refund the full amount of the commission to the Company.</li>
                      <li>Commissions will cease upon termination of the Agreement.</li>
                      <li>The Company reserves the right to terminate the agreement at its own discretion.</li>
                      <li>Other reasonable grounds for termination of the agreement include but are not limited to: fraudulent activations, damaging the Company's reputation, misleading customers, distributors, and/or retailers, and disclosing/misusing the customer’s personal information to unrelated parties.</li>
                      <li>Upon termination, the retailer has to return all the Company’s marketing material, tools, etc.</li>
                    </ul>
                  </div>
                  {checkBoxError && checkBox && (
                    <p className="error-label">{"please check the terms and conditions"} </p>
                  )}

                </div>

                <div className="formbold-checkbox-wrapper">
                  <label htmlFor="supportCheckbox" className="formbold-checkbox-label">
                    <div className="formbold-relative">
                      <input
                        type="checkbox"
                        id="supportCheckbox"
                        className="formbold-input-checkbox"
                        onChange={handleChange}
                        name="supportCheckbox"
                      />
                      <div className="formbold-checkbox-inner">
                        <span className="formbold-opacity-0">
                          <svg
                            width={11}
                            height={8}
                            viewBox="0 0 11 8"
                            className="formbold-stroke-current"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.81868 0.688604L4.16688 5.4878L2.05598 3.29507C1.70417 2.92271 1.1569 2.96409 0.805082 3.29507C0.453266 3.66742 0.492357 4.24663 0.805082 4.61898L3.30689 7.18407C3.54143 7.43231 3.85416 7.55642 4.16688 7.55642C4.47961 7.55642 4.79233 7.43231 5.02688 7.18407L10.0696 2.05389C10.4214 1.68154 10.4214 1.10233 10.0696 0.729976C9.71776 0.357624 9.17049 0.357625 8.81868 0.688604Z"
                              fill="white"
                            />
                          </svg>
                        </span>
                      </div>
                    </div>
                    <div>
                    I accept the Terms and Conditions.
                      {/* <a href="#"> terms and conditions,and policies</a> */}
                    </div>
                  </label>
                </div>
                <button className="formbold-btn" type="submit" disabled={disableButton}>Submit</button>
              </form>
              <button className="previous-btn" type="" onClick={handlePrevious} >Back</button>
            </div>
          </div>
          <style
            dangerouslySetInnerHTML={{
              __html:
                "\n  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');\n  * {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n  }\n  body {\n    font-family: 'Inter', sans-serif;\n  }\n  .formbold-mb-3 {\n    margin-bottom: 15px;\n  }\n  .formbold-relative {\n    position: relative;\n  }\n  .formbold-opacity-0 {\n    opacity: 0;\n  }\n  .formbold-stroke-current {\n    stroke: #ffffff;\n    z-index: 999;\n  }\n  #supportCheckbox:checked ~ div span {\n    opacity: 1;\n  }\n  #supportCheckbox:checked ~ div {\n    background: #6a64f1;\n    border-color: #6a64f1;\n  }\n\n  .formbold-main-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 48px;\n  }\n\n  .formbold-form-wrapper {\n    margin: 0 auto;\n    max-width: 570px;\n    width: 100%;\n    background: white;\n    padding: 40px;\n  }\n\n  .formbold-img {\n    display: block;\n    margin: 0 auto 45px;\n  }\n\n  .formbold-input-wrapp > div {\n    display: flex;\n    gap: 20px;\n  }\n\n  .formbold-input-flex {\n    display: flex;\n    gap: 20px;\n    margin-bottom: 15px;\n  }\n  .formbold-input-flex > div {\n    width: 50%;\n  }\n  .formbold-form-input {\n    width: 100%;\n    padding: 13px 22px;\n    border-radius: 5px;\n    border: 1px solid #dde3ec;\n    background: #ffffff;\n    font-weight: 500;\n    font-size: 16px;\n    color: #536387;\n    outline: none;\n    resize: none;\n  }\n  .formbold-form-input::placeholder,\n  select.formbold-form-input,\n  .formbold-form-input[type='date']::-webkit-datetime-edit-text,\n  .formbold-form-input[type='date']::-webkit-datetime-edit-month-field,\n  .formbold-form-input[type='date']::-webkit-datetime-edit-day-field,\n  .formbold-form-input[type='date']::-webkit-datetime-edit-year-field {\n    color: rgba(83, 99, 135, 0.5);\n  }\n\n  .formbold-form-input:focus {\n    border-color: #6a64f1;\n    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.05);\n  }\n  .formbold-form-label {\n    color: #536387;\n    font-size: 14px;\n    line-height: 24px;\n    display: block;\n    margin-bottom: 10px;\n  }\n\n  .formbold-checkbox-label {\n    display: flex;\n    cursor: pointer;\n    user-select: none;\n    font-size: 16px;\n    line-height: 24px;\n    color: #536387;\n  }\n  .formbold-checkbox-label a {\n    margin-left: 5px;\n    color: #6a64f1;\n  }\n  .formbold-input-checkbox {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border-width: 0;\n  }\n  .formbold-checkbox-inner {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 20px;\n    height: 20px;\n    margin-right: 16px;\n    margin-top: 2px;\n    border: 0.7px solid #dde3ec;\n    border-radius: 3px;\n  }\n\n  .formbold-form-file {\n    padding: 12px;\n    font-size: 14px;\n    line-height: 24px;\n    color: rgba(83, 99, 135, 0.5);\n  }\n  .formbold-form-file::-webkit-file-upload-button {\n    display: none;\n  }\n  .formbold-form-file:before {\n    content: 'Upload';\n    display: inline-block;\n    background: #EEEEEE;\n    border: 0.5px solid #E7E7E7;\n    border-radius: 3px;\n    padding: 3px 12px;\n    outline: none;\n    white-space: nowrap;\n    -webkit-user-select: none;\n    cursor: pointer;\n    color: #637381;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 16px;\n    margin-right: 10px;\n  }\n\n  .formbold-btn {\n    font-size: 16px;\n    border-radius: 5px;\n    padding: 14px 25px;\n    border: none;\n    font-weight: 500;\n    background-color: #6a64f1;\n    color: white;\n    cursor: pointer;\n    margin-top: 25px;\n  }\n  .formbold-btn:hover {\n    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.05);\n  }\n\n  .formbold-w-45 {\n    width: 45%;\n  }\n"
            }}
          />
        </>
      )}
      <style
        dangerouslySetInnerHTML={{
          __html:
            "\n  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');\n  * {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n  }\n  body {\n    font-family: \"Inter\", Arial, Helvetica, sans-serif;\n  }\n  .formbold-mb-5 {\n    margin-bottom: 20px;\n  }\n  .formbold-pt-3 {\n    padding-top: 12px;\n  }\n  .formbold-main-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 48px;\n  }\n\n  .formbold-form-wrapper {\n    margin: 0 auto;\n    max-width: 550px;\n    width: 100%;\n    background: white;\n  }\n  .formbold-form-label {\n    display: block;\n    font-weight: 500;\n    font-size: 16px;\n    color: #07074d;\n    margin-bottom: 12px;\n  }\n  .formbold-form-label-2 {\n    font-weight: 600;\n    font-size: 20px;\n    margin-bottom: 20px;\n  }\n\n  .formbold-form-input {\n    width: 100%;\n    padding: 12px 24px;\n    border-radius: 6px;\n    border: 1px solid #e0e0e0;\n    background: white;\n    font-weight: 500;\n    font-size: 16px;\n    color: #6b7280;\n    outline: none;\n    resize: none;\n  }\n  .formbold-form-input:focus {\n    border-color: #6a64f1;\n    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.05);\n  }\n\n  .formbold-btn {\n    text-align: center;\n    font-size: 16px;\n    border-radius: 6px;\n    padding: 14px 32px;\n    border: none;\n    font-weight: 600;\n    background-color: #6a64f1;\n    color: white;\n    width: 100%;\n    cursor: pointer;\n  }\n  .formbold-btn:hover {\n    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.05);\n  }\n\n  .formbold--mx-3 {\n    margin-left: -12px;\n    margin-right: -12px;\n  }\n  .formbold-px-3 {\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n  .flex {\n    display: flex;\n  }\n  .flex-wrap {\n    flex-wrap: wrap;\n  }\n  .w-full {\n    width: 100%;\n  }\n  @media (min-width: 540px) {\n    .sm\\:w-half {\n      width: 50%;\n    }\n  }\n"
        }}
      />
    </>


  )
}

export default inputField